'use client';

import { useMemo } from 'react';

/**
 * SSR-safe hook to get the current hostname
 * Returns empty string during SSR, actual hostname on client
 */
export const useHostname = () => {
  let t0;
  bb0: {
    if (typeof window === "undefined") {
      t0 = "";
      break bb0;
    }
    t0 = window.location.hostname;
  }
  return t0;
};